import React from 'react'

class Link extends React.Component{
    render(){
        return(
            <div className="link">
                <a href="https://fr.wikipedia.org/wiki/Temps_d%C3%A9cimal" rel="noopener noreferrer" target="_blank"> Temps décimal</a> |
                <a href="https://fr.wikipedia.org/wiki/Calendrier_r%C3%A9publicain" rel="noopener noreferrer" target="_blank"> Calendrier républicain</a>
            </div>
        )
    }
}

export default Link


// WEBPACK FOOTER //
// ./src/component/link/link.js